import { render, staticRenderFns } from "./devicemenu.vue?vue&type=template&id=52973d18&scoped=true&"
import script from "./devicemenu.vue?vue&type=script&lang=js&"
export * from "./devicemenu.vue?vue&type=script&lang=js&"
import style0 from "./devicemenu.vue?vue&type=style&index=0&id=52973d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52973d18",
  null
  
)

export default component.exports